// import { downloadGoogleDocAsPDF } from '../Utils/ResumeDownloader';

function About() {
  return (
    <div className="card-inner active" id="about-card">
      <div className="row card-container">
        {/* Card Wrap */}
        <div className="card-wrap col col-m-12 col-t-12 col-d-8 col-d-lg-6">
          <div className="content inner-top">
            <div className="row">
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                <div className="title-bg ">About Me</div>
                <div className="text">
                  <p>
                    <strong>Software Engineer</strong> with 5+ years of
                    experience building scalable cloud-native and AI-powered
                    applications across customer service, automation, and
                    full-stack platforms. Specialised in{' '}
                    <strong>AWS serverless ecosystems</strong>,{' '}
                    <strong>conversational AI</strong>, and distributed systems,
                    with hands-on expertise in{' '}
                    <strong>
                      Amazon Bedrock, Amazon Connect, Lambda, DynamoDB, Next.js,
                      and Terraform
                    </strong>
                    .
                    <br />
                  </p>
                </div>
                <div className="circle-bts">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/SharooqSalaudeen"
                  >
                    <i className="icon la la-github"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.linkedin.com/in/sharooq-salaudeen/"
                  >
                    <i className="icon la la-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
}

export default About;
